<template>
    <div class="container">

        <!-- Loading加载 -->
        <div class="loading" v-if="isDetail">
            <van-loading size="40px" type="spinner" color="#39CCCD" vertical>
                <div class="loading-text">
                    <div>页面正在加载</div>
                    <div>请稍候</div>
                </div>
            </van-loading>
        </div>

        <!-- 详情 -->
        <div class="content" v-html="detail.detail" v-show="!isDetail">
        </div>
        <div class="footer-fit" v-if="detail.id && !isDetail && !detail.purchased">
            <div class="bottom" v-if="isWXxcx">
                <div class="left">现在仅需：￥<span class="left-qian">{{ isHongbao=='close' ? detail.deduct : detail.price }}</span></div>
                <div class="right">
                    <div class="btn" @click.stop="handleEnroll(1)">
                        <div class="grab">前200名秒抢</div>
                        <div class="enroll">马上报名</div>
                    </div>
                </div>
            </div>
            <div class="bottom" v-else @click.stop="handleEnroll(2)">
                <div class="bottom2">马上报名</div>
            </div>
        </div>
        <!-- 详情回显 -->
        <div class="footer-fit" v-if="detail.id && !isDetail && detail.purchased">
            <div class="bottom">
                <div class="left" style="margin-left:20px">已购买</div>
                <div class="right">
                    <div class="btn" @click="to_link()">
                        马上学习
                    </div>
                </div>
            </div>
        </div>

        <HongbaoContent :drawDetail="detail" @handleCardShow="handleCardShow" 
            v-if="!isDetail && !detail.purchased && isWXxcx && isHongbao=='close'">
        </HongbaoContent>

        <!-- 去支付弹框 -->
        <div v-if="payShow">
            <div class="popup_mengceng" @click="payShow = false"></div>

            <div class="popup-content" @click="payShow = true">
                <div class="top">
                    <div style="width: 50%;text-align: center;">
                        <div class="p-t-top" style="color: red !important;">仅剩{{ textNum }}名</div>
                        <div class="p-t-bottom">剩余购课名额</div>
                    </div>
                    <div style="width: 50%;text-align: center;">
                        <div class="p-t-top">
                            <div class="width70px">{{ minutes }}</div>
                            <div>:</div>
                            <div class="width70px">{{ seconds }}</div>
                            <div>:</div>
                            <div class="width70px">{{ millisecond }}</div>
                        </div>
                        <div class="p-t-bottom">剩余支付时间</div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="left">
                        <span class="unit">¥</span><span class="price">{{ detail.price }}</span>
                        <div class="deduct">已减￥{{ (detail.deduct - detail.price).toFixed(1) }}</div>
                    </div>
                    <div class="right" @click.stop="getOrderDetail(true)">
                        立即支付
                    </div>
                </div>
            </div>
        </div> 

        <!-- 页面前往微信 -->
        <div class="qianwang_mengceng" v-if="!isWXxcx && !isDetail && isQianwang" @click="isQianwang = false">
            <div class="qianwang" @click="isQianwang = true">
                <div class="qw_top">
                    <img src="@/assets/logo1.png" class="img_log" />
                    <div class="dotting">
                        <div :class="dot == 1 ? 'yuan' : 'yuan2'"></div>
                        <div :class="dot == 2 ? 'yuan' : 'yuan2'"></div>
                        <div :class="dot >= 3 ? 'yuan' : 'yuan2'"></div>
                    </div>
                    <img src="@/assets/weixin_logo.png" class="img_log" />
                </div>
                <div style="padding-top: 25px;">即将前往微信小程序完成领取噢~</div>
            </div>
        </div>

    </div>
</template>
<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>
<!-- <script type="text/javascript" src="https://gitcode.net/dcloud/uni-app/-/raw/dev/dist/uni.webview.1.5.6.js"></script>
<script src="https://js.cdn.aliyun.dcloud.net.cn/dev/uni-webview/1.0.5/uni-webview.js"></script>  -->
<script type="module" src="@/utils/uni.weiview156.js"></script>

<script>
var that;
import wx from 'weixin-js-sdk'
import { Toast } from 'vant';
import HongbaoContent from '../../components/hongbao-content/hongbao-content.vue';

document.addEventListener('UniAppJSBridgeReady', function () {
    console.log('uni' +uni);

    uni.webView.getEnv(function (res) {
      console.log('当前环境：' + JSON.stringify(res));
    });
    // uni.webView.navigateTo(...)
  });

export default {
    name: 'index_two',
    components: {
        HongbaoContent
    },
    props: {},
    data() {
        return {
            id: '',
            bdVid: '',
            keywordid: '',
            token: '',
            isDetail: true,
            detail: {},
            payShow: false,
            minutes: '00',
            seconds: '00',
            millisecond: '00',
            intervalId: null,
            interval_miao: null,
            textNum: 28,
            countNum: 60,
            intervalCountNum: null,
            countdownTime: 0,
            orderId: '',
            isWXxcx: false,
            isOrderPay: '', //支付状态
            isQianwang: false,
            dot: 1,
            isHongbao: 'close',//用户没开过红包，那就显示过红包

        }
    },
    computed: {},
    created() {
        that = this
        that.id = this.$route.query.channel_id;
        that.bdVid = this.$route.query.bd_vid || this.$route.query.bdVid || '';
        that.keywordid = this.$route.query.keywordid || '';
        that.token = this.$route.query.token || '';//3e560ba8d0f54e3596275ba12023eed6
        that.isOrderPay = this.$route.query.isOrderPay || '';//3e560ba8d0f54e3596275ba12023eed6
        that.isHongbao = localStorage.getItem('isHongbao') || 'close';

        localStorage.setItem('token', that.token)
        if (!that.isWeixin()) {
            that.returnWX();
        }

        if(that.isOrderPay == '1'){//支付成功
            that.getConfig()
        }
        if(that.isOrderPay == '0'){//支付失败
            that.getOrderDetail()
        }
        that.getDetail()


        //有code并且已经登录跳转老师二维码页
        // const queryObj = this.getQueryObj()
        // if (queryObj['code'] && that.token) {
        //     that.btnWXcode(queryObj['code'])
        // } else {
        //     if(that.isOrderPay == '1'){//支付成功
        //         that.getConfig()
        //     }
        //     if(that.isOrderPay == '0'){//支付失败
        //         that.getOrderDetail()
        //     }
        //  } 
    },
    watch : {
        'isQianwang'(x,j) {
            if(x){
                setInterval(() => {
                    that.dot++
                    if(that.dot > 3){
                        that.dot = 1
                    }
                }, 300);
            }
        }
    },
    methods: {
        //isPay 是否手动点支付
        getOrderDetail(isPay = false) {
            that.$http.get('/app/channels/getOrder', {
                id: that.id,
            }).then(res => {
                if (!res.data) {//之前没有订单，去生成订单
                    if (isPay) {
                        that.addOrder()
                    }
                    return
                }
                that.orderId = res.data.id;

                // 状态(-1已取消0待付款1已付款)
                if (res.data.status === 1) {
                    if (isPay) {
                        setTimeout(() => {
                            that.to_link()
                        }, 500);
                    }
                }

                if (res.data.status === 0) {
                    if (isPay) {
                        that.JumpPay()
                    }else {
                        that.$router.push({
                            path: '/smallprogram/orderPay',
                            query: { id: that.id, orderId: that.orderId, automatic: 'to_false' }
                        })
                    }
                }
            }).catch(err => {
                if (err.code == 401) {
                    localStorage.removeItem('token')
                }
            })
        },

        addOrder() {
            this.$http.post('/app/orders/addByChannel', {
                orderSource: that.detail.channelName,
                courseId: that.detail.courseId,
                bdVid: that.bdVid,
                channelId: that.id
                // phone: that.form.phone
            }).then(res => {
                this.payShow = false;
                this.orderId = res.data;
                setTimeout(() => {
                    if (that.detail.price <= 0) {
                        that.getConfig()
                    }else {
                        that.JumpPay()
                    }
                }, 1000);
            })
        },

        getConfig() {
			var that = this
            //支付成功跳转最后一步展示页面
            this.$router.push({
                path: '/smallprogram/userInfo_code'
                // query: { id: this.id }
            })
            return //暂时关闭
            this.$http.post('/u/app/mp/config', {
				url: window.location.href
			}).then(res => {
				const result = res.data
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端
					appId: result.appId, // 必填，公众号的唯一标识
					timestamp: result.timestamp, // 必填，生成签名的时间戳
					nonceStr: result.nonceStr, // 必填，生成签名的随机串
					signature: result.signature, // 必填，签名
					jsApiList: ['getUserProfile']
				})
				wx.ready(() => {
					console.log('配置成功-fail-<')
					that.getWxInfo()
				})
				// 当配置不成功时执行
				wx.error(res => {
					// 输出错误信息
					console.log('-配置不成功-fail-<', res)
					if (res.errMsg && res.errMsg.includes('the permission value isoffline verifying')) {
						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端
							appId: result.appId, // 必填，公众号的唯一标识
							timestamp: result.timestamp, // 必填，生成签名的时间戳
							nonceStr: result.nonceStr, // 必填，生成签名的随机串
							signature: result.signature, // 必填，签名
							jsApiList: ['getUserProfile']
						})
						wx.ready(() => {
							console.log('配置成功2-fail-<')
							that.getWxInfo()
						})
					}
				})
			})
        },

        //支付成功后获取微信昵称头像
        getWxInfo() {
            wx.getUserProfile({
                desc: '获取你的昵称和头像', // 声明获取用户个人信息后的用途
                success: function(res) {
                    console.log(res.userInfo); // 用户信息
                    var userInfo = res.userInfo;
                    var nickName = userInfo.nickName; // 用户昵称
                    var avatarUrl = userInfo.avatarUrl; // 用户头像
                    Toast(nickName + '，' + avatarUrl);
                },
                fail: function(err) {
                    console.error(err);
                },
                style: 'bottom' // 设置为半屏样式
            });
            // console.log('获取vx授权code')
            // window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd06acaafd7167053&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`)
        },

        to_link() {
            this.$router.push({
                path: '/smallprogram/success'
                // query: { id: this.id }
            })
        },

        btnWXcode(code) {
            this.$http.post('/app/users/mergeMpInfo', {
                code: code
            }).then(res => {
                console.log(res)
                setTimeout(() => {
                    that.to_link()
                }, 500);
            })
        },

        handleCardShow(e) {
            console.log('步骤：', e)
            this.isHongbao = 'open';
            if(e == 3){
                this.payShow = true;
                this.getDownTime()
            }
        }, 

        // 设置倒计时间隔和初始更新
        getDownTime() {
            var that = this;
            that.countdownTime = that.countdownTime || new Date().getTime() + 15 * 60 * 1000 // 15分钟
            that.intervalId = setInterval(() => {
                that.updateCountdown(that.countdownTime)
            }, 200)
            that.millisecond = 99
            that.interval_miao = setInterval(() => {
                that.millisecond--
                if (that.millisecond < 10) {
                    that.millisecond = '0' + that.millisecond
                }
                if (that.millisecond <= 0) {
                    that.millisecond = 99
                }
            }, 10)
        },

        updateCountdown(endTime) {
            const now = new Date().getTime()
            const distance = endTime - now

            if (distance < 0) {
                that.countdownTime = 0
                this.minutes = '00'
                this.seconds = '00'
                this.clearTimer()
                return
            }

            this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)) + ''
            this.seconds = Math.floor((distance % (1000 * 60)) / 1000) + ''
            this.minutes = this.minutes.length < 2 ? '0' + this.minutes : this.minutes
            this.seconds = this.seconds.length < 2 ? '0' + this.seconds : this.seconds
        },

        clearTimer() {
            clearInterval(this.intervalId)
            this.intervalId = null
            clearInterval(this.interval_miao);
            this.interval_miao = null;
            this.millisecond = '00';
        },
        isWeixin() {
            // return this.token ? true : false;
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
                wx.miniProgram.getEnv((res) => {
                console.log(res)
                    if (res.miniprogram) {
                        console.log('在小程序里')
                        this.isWXxcx = true;
                        return true;
                    } else {
                        console.log('不在小程序里')
                        return false;
                    }
                })
            } else {
                console.log('不在微信里3')
                return false;
            }
        },

        async getDetail() {
            const res = await this.$http.get('/app/channels/getInfo', {
                id: this.id
            })
            console.log(res)
            if (res.code == 200) {
                this.detail = res.data;
                this.detail.detail = res.data.detail.replaceAll("<img ", "<img onclick='return false' ");
                this.detail.deduct = 99.9;
                this.detail.couponName = '学习红包';
                this.getCoursesDetail(res.data.courseId)

                document.title = res.data.title;
                setTimeout(() => {
                    this.isDetail = false;
                }, 500);
            } else {
                setTimeout(() => {
                    this.isDetail = false;
                    Toast('网络出现问题，请刷新重试!');
                }, 3000);
            }
        },

        // 获取课程详情
        getCoursesDetail(id) {
            var that = this;
            this.$http.get('/u/app/courses/detail', {
                id: id
            }).then(res => {
                console.log("数据" + res)
                that.detail.purchased = res.data.purchased;
                if(res.data.purchased){
					that.getAgainCourse()
				}
            })
        },
        
		//已购买训练营，如果训练营过期重新获取绑定最新训练营课程
		getAgainCourse() {
			this.$http.get('/app/users/updateTeacherByChannelId', {
				channelId: this.id
			}).then(res => {
				console.log('重新获取课程', res.data)
			})
		},

        // 获取授权后下单或直接下单
        handleEnroll(type) {
            if (type == 1) {
                this.handleCardShow(3)
            } else {
                //跳转微信小程序打开
                this.returnWX()
            }
        },

        //跳转微信小程序打开
        returnWX() {  
            // Toast('去小程序支付!' + that.orderId); 
            // console.log('jWeixin',wx)
            // wx.miniProgram.getEnv(function(res) {
			// 	if (res) {
			// 		wx.miniProgram.postMessage({
			// 			data: {
			// 				action: 'requestPayment',
            //                 orderId: that.orderId
			// 			}
			// 		})
			// 		wx.miniProgram.navigateBack({
			// 			delta: 1
			// 		})
			// 	}
			// }); 
            // return
            // this.$toast('跳转微信小程序打开') 
            this.isQianwang = true;
            setTimeout(() => {
                this.isQianwang = false;
            }, 5000);
            this.$http.get('/u/app/bd/getMaScheme', {
                bdVid: this.bdVid,
                keywordId: this.keywordid,
                channelId: this.id,
                path: 'packageB/pages/baidu/index'
            }).then(res => {
                console.log(res)
                window.location.href = res.data;
            })
        }, 

        getQueryObj() {
            var query = location.search
            var queryObj = {}
            var arr = query.slice(1, query.length).split('&')
            arr.forEach(function (val) {
                var arr1 = val.split('=')
                queryObj[arr1[0]] = arr1[1]
            })

            return queryObj
        },

        JumpPay() {
            console.log('jWeixin',wx)
            wx.miniProgram.getEnv(function(res) {
				if (res) {
					wx.miniProgram.postMessage({
						data: {
							action: 'requestPayment',
                            orderId: that.orderId
						}
					})
					wx.miniProgram.navigateBack({
						delta: 1
					})
				}
			}); 
            return

            // uni.webView.postMessage({ action: 'requestPayment', orderId: this.orderId });
            // uni.webView.navigateBack()
            // return

            // const message = { action: 'requestPayment', orderId: this.orderId };
            // // 优先使用微信环境方法
            // if (typeof wx !== 'undefined' && wx.miniProgram) {
            //     Toast('miniProgram'); 
            //   wx.miniProgram.postMessage({ data: message });
            // } else {
            //     Toast('parent'); 
            //   window.parent?.postMessage(message, '*');
            // }

            // uni.redirectTo({
			// 	url: '/packageB/pages/baidu/pay?channel_id=' + this.id + '&bdVid=' + this.bdVid +
			// 		'&keywordid=' + this.keywordid + '&token=' + this.token + '&orderId=' + this.orderId
			// }) 

            // uni.postMessage({  
            //     data: {  
            //         orderId: this.orderId
            //     }  
            // });  

            // window.parent.postMessage({ action: 'pay', orderId: '123' }, '*');

            // uni.redirectTo({
			// 	url: '/packageB/pages/baidu/detailedH5?channel_id=' + this.id + '&bdVid=' + this.bdVid + '&keywordid=' + this.keywordid + '&token=' + this.token + '&orderId=' + this.orderId
			// })
            // return
            // //与小程序通信
            // wx.miniProgram.postMessage({ data: { orderId: this.orderId } }); //小程序页面onMessage方法接收到的值为{ orderId: this.orderId }
        }


    }
}
</script>

<style scoped lang="less">
.qianwang_mengceng {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10076;

    .qianwang {
        position: fixed;
        left: 50%;
        top: 25%;
        transform: translate(-50%, -50%);
        background-color: #fff;
        border-radius: 16px;
        width: 84%;
        padding: 50px;
        font-size: 32px;
        color: #666;
        transition: all 0.3s ease;
        text-align: center;

        .qw_top {
            display: flex;
            align-items: center;
            justify-content: space-around;

            .img_log {
                width: 80px;
                height: 80px;
            }

            .dotting {
                display: flex;
                align-items: center;
                justify-content: space-around;
                width: 100px;

                .yuan {
                    width: 18px;
                    height: 18px;
                    border-radius: 20px;
                    background-color: #686868;
                    transition: all 0.3s ease;
                }

                .yuan2 {
                    width: 12px;
                    height: 12px;
                    border-radius: 20px;
                    background-color: #c5c5c5;
                    transition: all 0.3s ease;
                }
            }
        }
    }
}

.popup-content {
    width: 100%;
    background: #fff;
    color: #333;
    bottom: 0;
    left: 0;
    position: fixed;
    max-height: 100%;
    overflow-y: auto;
    border-radius: 50px 50px 0 0;
    z-index: 2002 !important;

    .top {
        padding: 40px 30px 100px 30px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: 20px 0 60px 0;
        padding: 20px 0;

        .p-t-top {
            font-size: 48px;
            font-weight: 600;
            color: #ff6933;
            font-family: PingFangSC-Medium;
            display: flex;
            align-items: center;
            justify-content: center;

            .width70px {
                width: 70px;
            }
        }

        .p-t-bottom {
            margin-top: 10px;
            font-size: 32px;
            color: #666;
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ff790d;
        padding: 15px 30px 30px 30px;

        .left {
            color: #fff;
            font-size: 80px;
            line-height: 80px;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            flex-wrap: nowrap;
            flex-shrink: 0;
            position: relative;

            .unit {
                font-size: 30px;
                line-height: 30px;
                position: absolute;
                left: 0;
                top: 25px;
                display: inline-block;
                font-family: PingFangSC-Medium;
            }

            .deduct {
                background-color: #ffff3f;
                border-radius: 8px;
                color: #ff790d;
                font-size: 28px;
                padding: 5px;
                line-height: 25px;
                font-family: sans-serif;
            }

            .price {
                padding: 18px;
                font-weight: 700;
                font-family: PingFangSC-Medium;
            }
        }

        .right {
            color: #ff790d;
            background: rgb(255, 255, 255);
            width: 300px;
            height: 100px;
            line-height: 100px;
            border-radius: 50px;
            text-align: center;
            font-weight: 700;
            font-size: 50px;
            animation: identifier .7s linear infinite;
        }

        @keyframes identifier {
            0% {
                transform: scale(.95);
            }

            50% {
                transform: scale(1.02);
            }

            100% {
                transform: scale(.95);
            }
        }
    }
}

.popup_mengceng {
    z-index: 2001;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .7);
}

@keyframes van-fade-out {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

.danmu {
    position: fixed;
    top: 20vh;
    left: 5vw;
    padding: 10px 20px;
    background: #00000075;
    color: #fff;
    font-size: 24px;
    border-radius: 50px;
}

.fade-in {
    animation: slide-up-fade-in 0.5s forwards;
}

@keyframes slide-up-fade-in {
    0% {
        transform: translateY(10px);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

.fade-out {
    animation: slide-up-fade-out 2s forwards;
}

@keyframes slide-up-fade-out {
    0% {
        transform: translateY(0);
        opacity: 1;
    }

    100% {
        transform: translateY(-30px);
        opacity: 0;
    }
}

.content img {
    pointer-events: none;
    cursor: default;
}

.loading {
    margin: 40vh auto;
    text-align: center;

    .loading-text {
        color: #39CCCD;
        font-weight: bold;
    }
}

.container {
    color: #333;
    font-size: 28px;
    // height: 100vh !important;
    height: 100%;
    display: flex;
    flex-direction: column;

    .content {
        flex: 1;
        position: relative;
        // padding-bottom: 140px;
        // height: 100vh !important; 
        overflow-y: auto;
        width: 100%;

        ::v-deep img {
            display: block;
            width: 100% !important;
        }
    }
}

.header-bg {
    width: 100vw;
}

.footer-fit {
    flex-shrink: 0;
    // position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 2;
    // background-color: rgb(255, 250, 240);
    background-color: #ffffff;

    .bottom {
        padding: 20px 30px 30px 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ff6033;

        .bottom2 {
            padding: 30px;
            background-color: red;
            line-height: 40px;
            font-weight: bold;
            font-size: 44px;
            width: 100%;
            border-radius: 100px;
            text-align: center;
            color: #ffffff;
        }
    }

    .left {
        // color: rgb(255, 36, 0);
        color: #ffffff;
        font-size: 42px;
        line-height: 40px;
        font-weight: 600;

        .left-qian {
            font-size: 45px;
            font-family: sans-serif;
        }
    }

    .right {
        position: relative;

        .finger {
            width: 100px;
            height: 100px;
            position: absolute;

            left: -60px;
            top: 50%;
            margin-top: -50px;

            z-index: 1;
            -webkit-animation: fadefinger 0.4s ease infinite alternate;
            animation: fadefinger 0.4s ease infinite alternate;
        }

        @keyframes identifier {
            0% {
                transform: scale(.95);
            }

            50% {
                transform: scale(1.02);
            }

            100% {
                transform: scale(.95);
            }
        }

        .btn {
            background-color: red;
            color: #fff;
            font-weight: 600;
            width: 300px;
            height: 100px;
            line-height: 100px;
            border-radius: 50px;
            text-align: center;
            animation: identifier .7s linear infinite;
            font-size: 44px;

            .grab {
                font-size: 22px;
                line-height: 22px;
                margin-bottom: 10px;
                padding-top: 10px;
            }

            .enroll {
                // line-height: 44px;
                line-height: 40px;
                font-weight: bold;
                font-size: 44px;
            }
        }
    }
}

@keyframes fadefinger {
    0% {
        transform: translateX(35px);
        -webkit-transform: translateX(35px);
    }

    100% {
        transform: translateX(0);
        -webkit-transform: translateX(0);
    }
}

@keyframes updown {
    0% {
        transform: translateY(8px);
        -webkit-transform: translateY(8px);
    }

    100% {
        transform: translateY(-8px);
        -webkit-transform: translateY(-8px);
    }
}


.van-popup {
    background: #f4f4f4;
}

.active {
    border: 4px solid #ff6d00 !important;
}
</style>